$ = jQuery;
/*Functions*/

/**
 * Hide Content on mobile
 */

function hideContent() {
    if ( $(window).width() < 768 ) {
        $('.bottom_content_second_part').removeClass('active');
        $('.expand_btn span:nth-child(2)').removeClass('active');
        $('.expand_btn span:nth-child(1)').addClass('active');
    } else {
        setTimeout( function () {
            $('.bottom_content_second_part').removeClass('active');
            $('.expand_btn span:nth-child(2)').removeClass('active');
            $('.expand_btn span:nth-child(1)').addClass('active');
        }, 3000 )
    }
}

/**
 * Columns for ul in content
 */
function columns_list() {
    var list = $('.content article, .bottom_content').find('ul:not(.table_of_content)');
    var list_items_count = null;
    list.each(function () {
        list_items_count = $(this).find('li').length;
        if(list_items_count > 5) {
            $(this).addClass('columns_list');
        }
    });
}

/**
 * Stars Rating
 */
function starsHover() {
    var ratingInner = $(".stars_rating.g_rating .g_rating_inner"),
        ratingInnerWidth = ratingInner.innerWidth(),
        ratingBlock = $(".stars_rating.g_rating"),
        id = $(".g_rating_block .count_number").attr('data-id');
    ratingCount = $(".g_rating_block .count_number span");
    ratingBlock.on("click", function() {
        if (!getCookie('added_rating' + id) && !$(this).data("clicked")) {
            ratingCount.text(parseInt(ratingCount.text()) + 1);
            console.log(ratingCount.text());
            var data = {
                'action': 'add_rating_count',
                'count': ratingCount.html(),
                'id': id
            };
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                data:data,
                type:'POST',
                success:function(data){
                    if( data ) {
                        ratingCount.text(data);
                    }
                }
            });
        }
        setCookie('added_rating' + id,'true',10);
        $(this).data("clicked", !0)
    });
    if(!getCookie('added_rating' + id) && !$(this).data("clicked")){
        ratingBlock.on("mousemove", function(e) {
            if (!$(this).data("clicked")) {
                var ratingInnerWidth = e.clientX - $(this).offset().left;
                ratingInner.css("width", ratingInnerWidth)
            }
        });
        ratingBlock.on("mouseleave", function(e) {
            ratingInner.css("width", ratingInnerWidth)
        })
    }
}

/*Redirection Button*/
function toReferral() {
    var btn = $('[data-casino]');
    btn.on('click',function (e) {
        var a = $(this),
            id = a.attr('data-casino'),
            bettingID = '/go-to/?id='+id+'';
        if(bettingID){
            window.open(bettingID);
        }
        else return false;
    });
}

/*Scroll top*/
function showScrollTop() {
    if ($(this).scrollTop() > 100) {
        $("#to_top").addClass('active');
    }
    else {
        $("#to_top").removeClass('active');
    }
}

$(document).ready(function () {
    "use strict";
    var siteBody = $("body");
    /*Init*/
    siteBody.addClass(currentBrowser()).addClass(detectmob());
    showScrollTop();
    columns_list();
    $(window).scroll(function () {
        showScrollTop();
    });
    /**
     * Stars Hover
     */

    if($(".g_rating")[0]){
        starsHover();
    }

    //referal
    toReferral();

    /*Scroll top Click*/
    $("#to_top").on("click","a", function (event) {
        event.preventDefault();
        var id  = $(this).attr('href'),
            top = $(id).offset().top;
        $('html, body').animate({scrollTop: top}, 1000);
    });
    /*Menu*/
    $("#menuOpen button.hamburger").on('click',function (e) {
        $('#mainMenu').toggleClass("opened");
        $(this).parent().toggleClass("opened");
        $(this).toggleClass('is-active');
    });
    $('#mainMenu li.menu-item-has-children').append('<span class="subMenuButton i-angle-down"></span>');
    $('.subMenuButton').on('click',function () {
        var t = $(this);
        if(t.hasClass('open')) {
            t.removeClass('open').prev().slideUp(300);
        } else {
            t.removeClass('open').prev().slideDown(300);
            t.addClass('open');
        }
    });
    //WPCF7
    $(this).on('click', '.wpcf7-not-valid-tip', function () {
        $(this).prev().trigger('focus');
        $(this).fadeOut(500, function () {
            $(this).remove();
        });
    });
    //Privacy
    if(!getCookie('privacy')){
        var privacy = $('#privacy');
        privacy.show();
    }
    $('#privacy .privacy_close').on('click',function () {
        $('#privacy').addClass('hide');
        setCookie('privacy','true',1);
    });
    //Games Slider
    new Swiper(".games_slider .swiper-container", {
        slidesPerView: 4,
        spaceBetween: 20,
        autoplayDisableOnInteraction: !1,
        loopFillGroupWithBlank: !0,
        preventClicks: !1,
        preventClicksPropagation: !1,
        navigation: {
            nextEl: ".games_slider .swiper-button-next",
            prevEl: ".games_slider .swiper-button-prev"
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: !1,
            waitForTransition: !0
        },
        breakpoints: {
            630: {
                slidesPerView: 2,
                loop: !0,
                speed: 1500,
                slidesPerGroup: 1,
            },
            800: {
                slidesPerView: 3,
                loop: !0,
                speed: 1500,
                slidesPerGroup: 1,
            },
            1024: {
                slidesPerView: 4,
                loop: !0,
                speed: 1500,
                slidesPerGroup: 1,
            }
        }
    });

    //Casinos Slider
    new Swiper(".sidebar_casinos_list .swiper-container", {
        direction: "vertical",
        slidesPerView: 4,
        speed: 1e3,
        loop: !0,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        loopFillGroupWithBlank: !0,
        autoplayDisableOnInteraction: !1,
        preventClicks: !0,
        preventClicksPropagation: !1,
        autoplay: {
            delay: 2500,
            disableOnInteraction: !1
        },
        navigation: {
            nextEl: ".sidebar_casinos_list .swiper-button-next",
            prevEl: ".sidebar_casinos_list .swiper-button-prev"
        },
        breakpoints: {
            767: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 5,
            }
        }
    });

    //Expand Button
    var expand = $('.expand_btn span');
    expand.on('click',function(){
        $(this).parent().prev().toggleClass('active');
        expand.toggleClass('active');
    });

    hideContent();

    /**
     * Table of content
     *
     */
    if( $('.is_toc h2')[0] ) {

        var toc = '<div class="table_of_content_block">\n' +
            '        <h4>'+ phpObject.toc_label +'</h4>\n' +
            '        <ul class="table_of_content"></ul>\n' +
            '    </div>\n';
        
        if($('.js_casino_table')[0]) {
            $('.js_casino_table').first().after(toc);
        } else {
            if( $('.top_payment_info')[0] && !$('.js_casino_table')[0] && !$('#paymentMenu')[0] ){
                $('.top_content').prepend(toc);
            } else {
                $('.is_toc').prepend(toc);
            }
        }


        $('.table_of_content').toc({
            content: $('.bottom_content'),
            headings: 'h2'
        });
        $('.table_of_content a').on("click", function (event) {
            event.preventDefault();
            var toc_id  = $(this).attr("href");
            if($('.bottom_content_second_part').find('h2[id="'+ toc_id +'"]')) {
                if(!$('.bottom_content_second_part').hasClass('active')) {
                    $('.expand_btn span.active').click();
                }
            }
            var top = $(toc_id).offset().top - 60;
            $('html, body').animate({scrollTop: top}, 1000);
        });
    }


    $('.t-show-all').click(function(){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.t-hide-more').removeClass('show');
            //$('.t-show-all__expand span').html('View more');
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".casino_table_main").offset().top
            }, 1000);
        } else {
            $(this).addClass('active');
            $('.t-hide-more').addClass('show');
            //$('.t-show-all__expand span').html('Less more');
        }
    });


    //GA
    $(window).on('load',function () {
        //Table (all tables except table on payment page) (buttons)
        $('html[lang="en-US"] .casino_table.no_payment_page button[data-casin-name]').on('click',function () {
            ga('send', 'event', 'visit-button-en', 'maintable_button', $(this).attr('data-casin-name'));
        });
        $('html[lang="de-DE"] .casino_table.no_payment_page button[data-casin-name]').on('click',function () {
            ga('send', 'event', 'visit-button-de', 'maintable_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .casino_table.no_payment_page button[data-casin-name]').on('click',function () {
            ga('send', 'event', 'visit-button-fr', 'maintable_button', $(this).attr('data-casin-name'))
        });
        //Table (all tables except table on payment page) (brand)
        $('html[lang="en-US"] .casino_table.no_payment_page .casino_title_and_thumbnail_item').on('click',function () {
            ga('send', 'event', 'review-button-en', 'main_table_brand_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="de-DE"] .casino_table.no_payment_page .casino_title_and_thumbnail_item').on('click',function () {
            ga('send', 'event', 'review-button-de', 'main_table_brand_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .casino_table.no_payment_page .casino_title_and_thumbnail_item').on('click',function () {
            ga('send', 'event', 'review-button-fr', 'main_table_brand_button', $(this).attr('data-casin-name'))
        });
        //Payments on front page
        $('html[lang="en-US"] .full_payments_list [data-payment-name]').on('click',function () {
            ga('send', 'event', 'payment-button-en', 'mainpage_button', $(this).attr('data-payment-name'))
        });
        $('html[lang="de-DE"] .full_payments_list [data-payment-name]').on('click',function () {
            ga('send', 'event', 'payment-button-de', 'mainpage_button', $(this).attr('data-payment-name'))
        });
        $('html[lang="fr-CA"] .full_payments_list [data-payment-name]').on('click',function () {
            ga('send', 'event', 'payment-button-fr', 'mainpage_button', $(this).attr('data-payment-name'))
        });
        //Single Casino Page
        $('html[lang="en-US"] .casino_top_info [data-casin-name]').on('click',function () {
            ga('send', 'event', 'play-button-en', 'review_page_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="de-DE"] .casino_top_info [data-casin-name]').on('click',function () {
            ga('send', 'event', 'play-button-de', 'review_page_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .casino_top_info [data-casin-name]').on('click',function () {
            ga('send', 'event', 'play-button-fr', 'review_page_button', $(this).attr('data-casin-name'))
        });
        //Table on payment page (buttons)
        $('html[lang="en-US"] .casino_table.payment_page button[data-casin-name]').on('click',function () {
            ga('send', 'event', 'visit-button-en', 'paysystem_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="de-DE"] .casino_table.payment_page button[data-casin-name]').on('click',function () {
            ga('send', 'event', 'visit-button-de', 'paysystem_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .casino_table.payment_page button[data-casin-name]').on('click',function () {
            ga('send', 'event', 'visit-button-fr', 'paysystem_button', $(this).attr('data-casin-name'))
        });
        //Table on payment page (Brand)
        $('html[lang="en-US"] .casino_table.payment_page .casino_title_and_thumbnail_item').on('click',function () {
            ga('send', 'event', 'review-button-en', 'payment_table_brand_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="de-DE"] .casino_table.payment_page .casino_title_and_thumbnail_item').on('click',function () {
            ga('send', 'event', 'review-button-de', 'payment_table_brand_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .casino_table.payment_page .casino_title_and_thumbnail_item').on('click',function () {
            ga('send', 'event', 'review-button-fr', 'payment_table_brand_button', $(this).attr('data-casin-name'))
        });
        //Slider (content)
        $('html[lang="en-US"] .games_slider [data-casin-name]').on('click',function () {
            ga('send', 'event', 'game-button-en', 'bottom_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="de-DE"] .games_slider [data-casin-name]').on('click',function () {
            ga('send', 'event', 'game-button-de', 'bottom_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .games_slider [data-casin-name]').on('click',function () {
            ga('send', 'event', 'game-button-fr', 'bottom_button', $(this).attr('data-casin-name'))
        });
        //Slider (sidebar)
        $('html[lang="en-US"] .sidebar_casinos_list [data-casin-name]').on('click',function () {
            ga('send', 'event', 'review-button-en', 'sidebar_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="de-DE"] .sidebar_casinos_list [data-casin-name]').on('click',function () {
            ga('send', 'event', 'review-button-de', 'sidebar_button', $(this).attr('data-casin-name'))
        });
        $('html[lang="fr-CA"] .sidebar_casinos_list [data-casin-name]').on('click',function () {
            ga('send', 'event', 'review-button-fr', 'sidebar_button', $(this).attr('data-casin-name'))
        });
    });

});